// src/services/VersionService.js
import axios from './api'

/**
 * Fetches the API version information from the backend.
 * @returns {Promise<Object>} The version data from the response.
 * @throws {Error} If the request fails.
 */
export const getApiVersion = async () => {
    try {
        const response = await axios.get('/api/version/')
        return response.data
    } catch (error) {
        console.error('Failed to fetch API version:', error)
        throw error
    }
}
